import React from 'react';
import TagManager from 'react-gtm-module';
import styles from './LandingHero.module.scss';

const LandingHero = ({
  currentCountry,
  onOpenCotizador
}) => {
  const handleCotizarClick = () => {
    onOpenCotizador();
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'landing_hero_solicitar_cotizacion',
          event_category: 'engagement',
          event_label: 'Solicitud de Cotización - Landing',
          value: null,
          slug: null
        }
      });
    }
  };

  const handleVerMaquinariaClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'landing_hero_ver_maquinaria',
          event_category: 'engagement',
          event_label: 'Ver Maquinaria - Landing',
          value: null,
          slug: null
        }
      });
    }
    window.open('/productos', '_blank');
  };

  return (
    <div className={styles.hero}>
      <div className={styles.textSection}>
        <h1 className={styles.title}>
          <span>Maquinaria</span> <span>pesada</span> <span>de</span>{' '}
          <span>alta</span> <span>calidad</span> <span>para</span>{' '}
          <span>minería,</span> <span>construcción</span> <span>y</span>{' '}
          <span>agro</span> <span>en</span> <span>{currentCountry}</span>
        </h1>
        <p className={styles.subtitle}>
          Nueve líneas de equipos combinando innovación, tecnología inteligente y soluciones sostenibles.
        </p>
        <div className={styles.buttonWrapper}>
          <button
            className={styles.contactButton}
            onClick={handleCotizarClick}
          >
            COTIZAR
          </button>
          <button
            className={styles.catalogueButton}
            onClick={handleVerMaquinariaClick}
          >
            VER MAQUINARIA
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingHero;
